var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.4115 1.77783H3.70632C2.8292 1.77783 2.11816 2.57377 2.11816 3.5556V14.2222C2.11816 15.204 2.8292 16 3.70632 16H16.4115C17.2887 16 17.9997 15.204 17.9997 14.2222V3.5556C17.9997 2.57377 17.2887 1.77783 16.4115 1.77783Z",
    fill: "#FFF7EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3531 0H0.530361C0.38996 0 0.255309 0.0624335 0.15603 0.173566C0.0567509 0.284698 0.000976562 0.435425 0.000976562 0.592589V13.6296C0.000976562 13.7867 0.0567509 13.9374 0.15603 14.0486C0.255309 14.1597 0.38996 14.2221 0.530361 14.2221H15.3531C15.4935 14.2221 15.6282 14.1597 15.7275 14.0486C15.8267 13.9374 15.8825 13.7867 15.8825 13.6296V0.592589C15.8825 0.435425 15.8267 0.284698 15.7275 0.173566C15.6282 0.0624335 15.4935 0 15.3531 0ZM1.05975 13.037V1.18518H14.8237V13.037H1.05975Z",
    fill: "#FFF7EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6961 1.04296L8.23709 8.15403C8.14108 8.24568 8.01898 8.29591 7.89279 8.2957C7.76661 8.29548 7.64465 8.24482 7.54889 8.15284L0.184092 1.04177C0.102108 0.962804 0.0436997 0.857619 0.0167265 0.740373C-0.0102467 0.623127 -0.00449026 0.499446 0.0332211 0.385972C0.0709324 0.272498 0.138789 0.174678 0.22766 0.105673C0.316531 0.0366674 0.422152 -0.000210634 0.53031 9.04991e-07H15.3531C15.4612 0.000233415 15.5667 0.0375263 15.6553 0.106864C15.7439 0.176201 15.8115 0.274258 15.8488 0.387845C15.8862 0.501432 15.8916 0.625102 15.8643 0.742221C15.837 0.85934 15.7783 0.964291 15.6961 1.04296ZM13.9153 1.18518H1.95435L7.89617 6.92263L13.9153 1.18518Z",
    fill: "#FFF7EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7b1b46608a63a29e69466dabf2328e6a.svg";
export { ForwardRef as ReactComponent };